// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as SWRUtils$Showside from "../utils/SWRUtils.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as IntersectionObserver$Showside from "../utils/IntersectionObserver.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function RelatedProductsContent(Props) {
  var productId = Props.productId;
  var categoryId = Props.categoryId;
  var hideOutOfStock = Props.hideOutOfStock;
  var viewport = Props.viewport;
  var render = Props.render;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var account = match$2.transitiveAccount;
  var configId = match$2.id;
  var match$3 = EntrypointContext$Showside.use(undefined);
  var swr = UseApi$Showside.useRelatedProducts(productId, match$2.transitiveStoreId, categoryId, hideOutOfStock, true, match$3.smartnavApiHost, match$3.market, undefined);
  var match$4 = SWRUtils$Showside.getPageInfo(swr, function (page) {
    return page.page.next;
  }, function (page) {
    return page.products;
  });
  var setSize = match$4.setSize;
  var size = match$4.size;
  var error = swr.error;
  var products = Belt_Option.getWithDefault(match$4.contents, []);
  var previousProducts = Previous$Showside.usePreviousDistinct(products);
  var products$1 = products.length === 0 ? previousProducts : products;
  React.useEffect(function () {
    if (products$1.length !== 0) {
      var newrecord = Caml_obj.obj_dup(LegacyShowside_CategoryDecoders$ApiTypes.empty);
      UseTracking$Showside.trackRetargeting(account, configId, (newrecord.title = "Related Products", newrecord.id = "related-products", newrecord), undefined, undefined, isMobile, undefined, undefined, undefined, products$1, undefined, "view_item_list");
    }
  }, [Belt_Array.joinWith(products$1, "|", function (p) {
    return p.id;
  })]);
  var lastPageRef = React.useRef(null);
  var match$5 = IntersectionObserver$Showside.use(lastPageRef, viewport, undefined, [0.5], undefined, undefined, undefined, undefined);
  var isIntersecting = match$5.isIntersecting;
  var loadedAll = match$4.numLoadedPages >= size;
  React.useEffect(function () {
    if (isIntersecting && loadedAll) {
      Curry._1(setSize, size + 1 | 0);
    }
  }, [isIntersecting, loadedAll, setSize, size]);
  var loading = React.createElement(ConditionalRender$Showside.When.make, {
    condition: !match$4.reachedEnd && error === undefined,
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(lastPageRef),
      className: CSS$Showside.prefix("h-12 text-center flex items-center justify-center")
    }, "Loading more products...")
  });
  return React.createElement("div", undefined, Curry._1(render, products$1), loading);
}
RelatedProductsContent.displayName = "RelatedProductsContent";
var make = RelatedProductsContent;
export { make };
/* react Not a pure module */